(function () {
  if (window.__harloweDecisionEventsInstalled) return;
  window.__harloweDecisionEventsInstalled = true;

  var recent = new Map();

  function clean(value, maxLength) {
    return String(value || '').trim().replace(/\s+/g, ' ').slice(0, maxLength || 180);
  }

  function classify(text) {
    text = clean(text, 800).toLowerCase();
    if (/light[-_ ]?finder|find[-_ ]?your[-_ ]?light/.test(text)) return 'light_finder_start';
    if (/recommend(ed|ation)|finder[-_ ]?result/.test(text)) return 'light_finder_complete';
    if (/compare|comparison/.test(text)) return 'product_compare';
    if (/buying[-_ ]?guide|which[-_ ]?(harlowe[-_ ]?)?light|shop[-_ ]?by[-_ ]?shoot/.test(text)) return 'buying_guide_click';
    if (/compatib|camera[-_ ]?fit|ttl|hss/.test(text)) return 'compatibility_check';
    if (/creator[-_ ]?kit|starter[-_ ]?kit|standard[-_ ]?kit|midnight[-_ ]?(creator|standard)[-_ ]?kit|pro[-_ ]?(add[-_ ]?on|upgrade|kit)|bundle|kit[-_ ]?option/.test(text)) return 'kit_option_select';
    return '';
  }

  function publish(target, sourceType) {
    if (!target || !window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;
    var href = target.href || target.getAttribute('href') || '';
    var value = target.value || target.getAttribute('aria-label') || target.textContent || '';
    var id = target.id || '';
    var combined = [id, value, href, target.name || '', target.className || ''].join(' ');
    var eventName = classify(combined);
    if (!eventName) return;

    var signature = [eventName, location.pathname].join('|');
    var now = Date.now();
    if (recent.has(signature) && now - recent.get(signature) < 1500) return;
    recent.set(signature, now);

    Shopify.analytics.publish('harlowe:decision_event', {
      event_name: eventName,
      decision_value: clean(value, 180),
      source_element_id: clean(id, 160),
      link_url: clean(href, 500),
      source_type: clean(sourceType, 30)
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest('a,button,[role="button"],input,select,label,summary')
      : null;
    publish(target, 'click');
  }, true);

  document.addEventListener('change', function (event) {
    publish(event.target, 'change');
  }, true);
})();
